var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.419 9L0 57.195l51.795 41.65 74.419-46.41L74.419 9zM0 139.305l74.419 48.79 51.795-43.435-74.419-45.815L0 139.305zm126.214 5.355l52.391 43.435 73.823-48.195-51.2-41.055-75.014 45.815zm126.214-87.465L178.605 9l-52.391 43.435 75.014 46.41 51.2-41.65zM126.809 154.18l-52.39 43.435L52.39 182.74v16.66l74.418 44.625 74.419-44.625v-16.66l-22.623 14.875-51.796-43.435z",
    fill: "#007EE5"
  })));
}

export default SvgDropbox;